// We need jQuery
//var $ = window.jQuery;
import select2 from '../shared/select2';

export default {
    loaded() {
        select2()
    }
}
